import CurrentFastProgressVisualization, {
   type CurrentFastProgressVisualizationState,
} from './CurrentFastProgressVisualization'
import ProgressContainer, { type ProgressContainerProps } from './ProgressContainer'

type CurrentFastProgressOverviewProps = ProgressContainerProps & {
   visualizationState: CurrentFastProgressVisualizationState
}

/**
 * Shows the current fast's headline figures (elapsed/remaining, target, fat burned).
 *
 * @param props - The overview data.
 * @returns The overview element.
 */
const CurrentFastProgressOverview = (props: CurrentFastProgressOverviewProps) => (
   <div class="flex flex-col">
      <ProgressContainer
         active={props.active}
         displayMode={props.displayMode}
         fatBurnLabel={props.fatBurnLabel}
         fatBurnTitle={props.fatBurnTitle}
         onToggleDisplayMode={props.onToggleDisplayMode}
         progressBackground={props.progressBackground}
         progressLabel={props.progressLabel}
         syncLoading={props.syncLoading}
         timerLabel={props.timerLabel}
         toggleLabel={props.toggleLabel}
      />
      <CurrentFastProgressVisualization state={props.visualizationState} />
   </div>
)

export default CurrentFastProgressOverview
